<template>
   <a-modal v-model="visible" title="Reset Password" :destroyOnClose="true">
    <a-form-model ref="resetPassword" :model="resetPassword" :rules="rules" layout="vertical">
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-model-item label="Current Password" prop="currentPassword"> 
            <a-input placeholder="Current Password" type="password" v-model="resetPassword.currentPassword" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="New Password" prop="newPassword">
            <a-input placeholder="New Password" type="password" v-model="resetPassword.newPassword" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="Confirm New Password" prop="confirmNewPassword">
            <a-input placeholder="Confirm New Password" type="password" v-model="resetPassword.confirmNewPassword" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <template #footer>
      <a-button type="primary" @click="reset" :loading="isSaving">Reset</a-button>
      <a-button @click="cancel">Cancel</a-button>
    </template>
  </a-modal>
</template>
<script>
export default {
  props: {
    value: Boolean,
  },
  data() {
    return {
      resetPassword:{
          currentPassword:'',
          newPassword:'',
          confirmNewPassword:'',
      }  ,
      rules: {
        currentPassword: [{ required: true, message: 'Please input old Password', trigger: 'blur' }],
        newPassword: [{ required: true, message: 'Please input password', trigger: 'blur' }],
        confirmNewPassword: [
          { required: true, message: 'Please input Confirm Password', trigger: 'blur' },
          { validator: this.confirmPasswordValidator, trigger: 'blur' },
        ],
      },
      isSaving: false,
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.resetPassword={
          currentPassword:'',
          newPassword:'',
          confirmNewPassword:'',
      };
        this.$emit('input', val);
      },
    },
  },
  methods: {
    confirmPasswordValidator(_, value, callback) {
      if (value && value !== this.resetPassword.newPassword) {
        callback('The two passwords are inconsistent');
      }
      callback();
    },
    cancel() {
      this.visible = false;
    },
    reset() {
      this.$refs.resetPassword.validate(async (valid) => {
        if (valid) {
          this.isSaving = true;

          try {
            await this.$resetPassword({
              currentPassword: this.resetPassword.currentPassword,
              newPassword: this.resetPassword.newPassword
            });
             this.$message.success("Password Reseted.");
            this.visible = false;
          } catch (error) {
            this.$message.error(error.response?.data?.errors[0]?.message ?? error.message);
          } finally {
            this.isSaving = false;
          }
        }
      });
    },
  },
};
</script>